module.exports = __webpack_public_path__ + "static/img/2.43195fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/2.png
// module id = Duez
// module chunks = 84